import { useState, useEffect } from "react";
import { useGetAccount } from "./sdkDappHooks";

interface UserData {
  gold: number;
  gems: number;
  address: string;
}

export const useGetUserData = (): {
  userData: UserData | null;
  isLoading: boolean;
} => {
  const [userData, setUserData] = useState<UserData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { address } = useGetAccount();

  useEffect(() => {
    if (address) {
      // Mock data - in a real app, this would fetch from an API
      setTimeout(() => {
        setUserData({
          gold: 100,
          gems: 100,
          address: address,
        });
        setIsLoading(false);
      }, 500);
    } else {
      setUserData(null);
      setIsLoading(false);
    }
  }, [address]);

  return { userData, isLoading };
};
